const state = {
  library: {
    selectedTab: "songs"
  }
};

const getters = {};

const mutations = {
  SET_LIBRARY_SELECTED_TAB({ library }, tab) {
    library.selectedTab = tab;
  }
};

const actions = {
  setLibrarySelectedTab({ commit }, tab) {
    commit("SET_LIBRARY_SELECTED_TAB", tab);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
